import styled from "styled-components"

export const StyledFoodDetails = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
`

export const FoodDetailsHeader = styled.div`
  position: absolute;
  height: 44px;
  padding: 0 16px;
  width: 100%;
  display: flex;
  align-items: center;
  z-index: 1000;
  justify-content: space-between;

  svg {
    cursor: pointer;
  }
`

export const FoodDetailsContent = styled.div`
  overflow-y: auto;
  height: calc(100% - var(--app-cta-height));
  display: flex;
  flex-direction: column;
`

export const FoodDetailsInfo = styled.div`
  padding: 16px;
  padding-bottom: 0;
  gap: 8px;
  display: flex;
  flex-direction: column;

  margin-top: -50px;
  z-index: 100;
  position: relative;
  padding-top: 0;
`
